/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelfacebook2Inputs */

const en_sharechannelfacebook2 = /** @type {(inputs: Sharechannelfacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

const de_sharechannelfacebook2 = /** @type {(inputs: Sharechannelfacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

/**
* | output |
* | --- |
* | "Facebook" |
*
* @param {Sharechannelfacebook2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelfacebook2 = /** @type {((inputs?: Sharechannelfacebook2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelfacebook2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelfacebook2(inputs)
	return de_sharechannelfacebook2(inputs)
});
export { sharechannelfacebook2 as "shareChannelFacebook" }